import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Auth0Authenticated from 'src/components/Auth0Authenticated/Auth0Authenticated';
import Authenticated from 'src/components/Authenticated/Authenticated';
import SegmentAnalytics from 'src/components/SegmentAnalytics/SegmentAnalytics';
import Urls from 'src/config/routes';
import BoostedAd from 'src/views/BoostedAd/BoostedAd';
import Dashboard from 'src/views/Dashboard/Dashboard';
import Enquiries from 'src/views/Enquiries/Enquiries';
import Franchise from 'src/views/Franchise/Franchise';
import { MarketplaceInsights } from 'src/views/MarketplaceInsights/MarketplaceInsights';
import NotFound from 'src/views/NotFound/NotFound';
import Onboarding from 'src/views/Onboarding/Onboarding';
import PackagesPage from 'src/views/PackagesPage/PackagesPage';
import Checkout from 'src/views/Payment/components/Checkout/Checkout';
import ConfirmCheckout from 'src/views/Payment/components/ConfirmCheckout/ConfirmCheckout';
import { FreemiumContract } from 'src/views/Payment/components/Contract/FreemiumContract';
import { PayPerEnquiryContract } from 'src/views/Payment/components/Contract/PayPerEnquiryContract';
import PaymentSuccess from 'src/views/Payment/components/PaymentSuccess/PaymentSuccess';
import PostListing from 'src/views/PostListing/PostListing';
import Preferences from 'src/views/Preferences/Preferences';
import PreferencesSubmitted from 'src/views/PreferencesSubmitted/PreferencesSubmitted';
import { PriceGuide } from 'src/views/PriceGuide/PriceGuide';
import { PriceGuideEstimation } from 'src/views/PriceGuide/PriceGuideEstimation';
import { PriceGuideOperations } from 'src/views/PriceGuide/PriceGuideOperations';
import PrivateSellerSEM from 'src/views/PrivateSellerSEM/PrivateSellerSEM';
import PrivateSellerSEMv2 from 'src/views/PrivateSellerSEMv2/PrivateSellerSEM';
import Profile from 'src/views/Profile/Profile';
import RecommendationUnsubscribe from 'src/views/RecommendationUnsubscribe/RecommendationUnsubscribe';
import RenewListing from 'src/views/RenewListing/RenewListing';
import RenewListingSuccess from 'src/views/RenewListingSuccess/RenewListingSuccess';
import Unsubscribe from 'src/views/Unsubscribe/Unsubscribe';

const Router = () => (
  <Routes>
    <Route
      path={Urls.BOOSTED_AD}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_boosted_ad">
            <BoostedAd />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.RENEW_LISTING}
      element={
        <Auth0Authenticated>
          <SegmentAnalytics pageTitle="sell_renew_listing">
            <RenewListing />
          </SegmentAnalytics>
        </Auth0Authenticated>
      }
    />
    <Route
      path={Urls.RENEW_LISTING_SUCCESS}
      element={
        <SegmentAnalytics pageTitle="sell_renew_listing_success">
          <RenewListingSuccess />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.FRANCHISE_HUB}
      element={
        <SegmentAnalytics pageTitle="franchises_licensing_distribution">
          <Franchise />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.RECOMMENDATION_UNSUBSCRIBE}
      element={
        <SegmentAnalytics pageTitle="buyer_recommendation_unsubscribe">
          <RecommendationUnsubscribe />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.PREFERENCES_SUBMITTED}
      element={
        <SegmentAnalytics pageTitle="buyer_preferences_submitted">
          <PreferencesSubmitted />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.BUYER_PREFERENCES}
      element={
        <SegmentAnalytics pageTitle="buyer_preferences">
          <Preferences />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.DASHBOARD}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_dashboard">
            <Dashboard />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAYMENT}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_payment">
            <Checkout />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAYMENT_CONFIRM}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_payment_confirm">
            <ConfirmCheckout />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAYMENT_SUCCESS}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_payment_success">
            <PaymentSuccess />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PACKAGES}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_packages">
            <PackagesPage />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PAY_PER_ENQUIRY_CONTRACT}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_pay_per_enquiry_contract">
            <PayPerEnquiryContract />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.FREEMIUM_CONTRACT}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_free_listing_contract">
            <FreemiumContract />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.ONBOARDING}
      element={
        <Auth0Authenticated>
          <SegmentAnalytics pageTitle="onboarding">
            <Onboarding />
          </SegmentAnalytics>
        </Auth0Authenticated>
      }
    />
    <Route
      path={Urls.POST_LISTING}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="sell_listing_repost">
            <PostListing />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRICE_GUIDE}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="price_guide">
            <PriceGuide />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRICE_GUIDE_ESTIMATION}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="price_guide">
            <PriceGuideEstimation />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.PRICE_GUIDE_OPERATIONS}
      element={
        <Authenticated>
          <SegmentAnalytics pageTitle="price_guide">
            <PriceGuideOperations />
          </SegmentAnalytics>
        </Authenticated>
      }
    />
    <Route
      path={Urls.LISTING_ENQUIRIES}
      element={
        <Auth0Authenticated>
          <SegmentAnalytics pageTitle="sell_listings_enquiries">
            <Enquiries />
          </SegmentAnalytics>
        </Auth0Authenticated>
      }
    />
    <Route
      path={Urls.PROFILE_DETAILS}
      element={
        <Auth0Authenticated>
          <SegmentAnalytics pageTitle="my_profile">
            <Profile />
          </SegmentAnalytics>
        </Auth0Authenticated>
      }
    />
    <Route
      path={Urls.PROFILE_SAVED_BUSINESSES}
      element={
        <Auth0Authenticated>
          <SegmentAnalytics pageTitle="my_profile">
            <Profile />
          </SegmentAnalytics>
        </Auth0Authenticated>
      }
    />
    <Route
      path={Urls.PROFILE_SAVED_SEARCHES}
      element={
        <Auth0Authenticated>
          <SegmentAnalytics pageTitle="my_profile">
            <Profile />
          </SegmentAnalytics>
        </Auth0Authenticated>
      }
    />
    <Route
      path={Urls.PRIVATE_SELLER_SEM}
      element={
        <SegmentAnalytics pageTitle="sell_your_business_sem_v1">
          <PrivateSellerSEM />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.PRIVATE_SELLER_SEM_V2}
      element={
        <SegmentAnalytics pageTitle="sell_your_business_sem_v2">
          <PrivateSellerSEMv2 />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.UNSUBSCRIBE}
      element={
        <SegmentAnalytics pageTitle="unsubscribe">
          <Unsubscribe />
        </SegmentAnalytics>
      }
    />
    <Route
      path={Urls.MARKETPLACE_INSIGHTS}
      element={
        <SegmentAnalytics pageTitle="marketplace_insights">
          <MarketplaceInsights />
        </SegmentAnalytics>
      }
    />
    <Route path={Urls.PAGE_NOT_FOUND} element={<NotFound />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default Router;
